import React from "react";
import Carousel from "react-multi-carousel";
import { Image, Container } from "react-bootstrap";
import "react-multi-carousel/lib/styles.css";

import navarrow from "../assets/navarrow.svg";
import { Link } from "react-router-dom";

import "./projects.css";
import { ExternalLink } from "react-external-link";

const Dataset = [
  {
    id: "0",
    captionTitle: "Adept",
    captionDescription:
      " Adept is a SaaS edu-fintech platform designed for basic and tertiary schools to streamline fee collection and administrative tasks",
    imageUrl: "/assets/Adeptbanner.png",
    isExternal: false,
    link: "/project/adept",
    sub: ["ui design","frontend"],
  },
  {
    id: "1",
    captionTitle:"Buidl",
    captionDescription:
      " Buidl is an innovative platform designed to connect talented individuals and teams with builders in the Web3 space.",
    imageUrl: "/assets/build.png",
    isExternal: false,
    link: "/project/buidl",
    sub: ["ui design","web-3 design"],
  },
   {
    id: "2",
    captionTitle: "Loda Branding",
    captionDescription:
      "Brand design for Lodapoint (Easy moves,Endless possibilities) For quick rides, heavy loads and delivery services.",
    imageUrl: "/assets/lodabrandbanner.png",
    isExternal: false,
    link: "/project/lodabranding",
    sub: ["branding"],
  },
  {
    id: "3",
    captionTitle: "Notarary Meets",
    captionDescription:
      " Designed landing page to facilitate paid meetings between the user and the notary officer.",
    imageUrl: "/assets/notorarymeet.png",
    isExternal: false,
    link: "/project/notarymeet",
    sub: ["ui design"],
  },
  {
    id: "4",
    captionTitle: "OLA",
    captionDescription:
      "A journey of how I developed my brand identity and style guide.",
    imageUrl: "/assets/olabanner.png",
    isExternal: false,
    link: "/project/ola",
    sub: ["branding"],
  },
  {
    id: "5",
    captionTitle: "Edge Marketing",
    captionDescription:
      "A Visually Engaging Website to Boost Affiliate Marketing Success",
    imageUrl: "/assets/edgemarketing.png",
    isExternal: true,
    link: "/project/edgemarketing",
    sub: ["ui-design"],
  },
  {
    id: "6",
    captionTitle: "Watimagbo",
    captionDescription:
      "An intuitive mobile app designed for music enthusiasts, offering user-friendly features.",
    imageUrl: "/assets/watimagbo.png",
    isExternal: true,
    link: "https://www.behance.net/gallery/135597889/watimagbo-(Music-App)",
    sub: ["ui design", "branding"],
  },
  {
    id: "7",
    captionTitle: "TheLoda Website",
    captionDescription:
      "An intuitive mobile app designed for music enthusiasts, offering user-friendly features.",
    imageUrl: "/assets/theloda.png",
    isExternal: true,
    link: "https://www.behance.net/gallery/135597889/watimagbo-(Music-App)",
    sub: ["ui design", "ui development"],
  },
];




function ProjectList({ responsive }) {
  return (
    <>
      <Carousel
        additionalTransfrom={0}
        arrows={true}
        autoPlaySpeed={3000}
        centerMode={false}
        className=""
        containerClass="container-with-dots"
        dotListClass=""
        draggable
        focusOnSelect={false}
        infinite
        itemClass=""
        keyBoardControl
        minimumTouchDrag={80}
        pauseOnHover
        renderArrowsWhenDisabled={false}
        renderButtonGroupOutside={false}
        renderDotsOutside={false}
        responsive={responsive}
        rewind={false}
        rewindWithAnimation={false}
        rtl={false}
        shouldResetAutoplay
        showDots={false}
        sliderClass=""
        slidesToSlide={1}
        swipeable
      >
        {Dataset.map((item) => (
          <Container fluid key={item.id}>
             {item.isExternal ? (
            <ExternalLink href={item.link} target="_blank" rel="noopener noreferrer">
              <figure className="figure-container">
                <Image
                  width="100%"
                  src={item.imageUrl || "/placeholder.jpg" }
                  alt={item.captionTitle}
                />
                <figcaption style={{ padding: "0.7rem" }} className="caption">
                  <div style={{ display: "flex", gap: 5 }}>
                    <div>
                      <h6 style={{ fontFamily: "Clash Display" }}>
                        <strong>{item.captionTitle}</strong>
                      </h6>
                      <p
                        style={{
                          fontSize: "0.7rem",
                          fontFamily: 'Jost, sans-serif',
                          lineHeight: "199%",
                        }}
                      >
                        {item.captionDescription}
                      </p>
                    </div>
                    <div>
                      <Image style={{ marginTop: "50%" }} src={navarrow} />
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      gap: "10px",
                      flexWrap: "wrap",
                      marginBottom: "0.5rem",
                    }}
                  >
                    {item.sub.map((subItem) => (
                      <div
                        style={{
                          fontSize: "0.65rem",
                          backgroundColor: "grey",
                          borderRadius: "5rem",
                          padding: "0.3rem 1rem",
                        }}
                        key={subItem}
                      >
                        {subItem}
                      </div>
                    ))}
                  </div>
                </figcaption>
              </figure>
            </ExternalLink>
          ) : (
            <Link to={item.link}>
              <figure className="figure-container">
                <Image
                  width="100%"
                  src={item.imageUrl}
                  alt={item.captionTitle}
                />
                <figcaption style={{ padding: "0.7rem" }} className="caption">
                  <div style={{ display: "flex", gap: 5 }}>
                    <div>
                      <h6 style={{ fontFamily: "Clash Display" }}>
                        <strong>{item.captionTitle}</strong>
                      </h6>
                      <p
                        style={{
                          fontSize: "0.67rem",
                           fontFamily: 'Jost, sans-serif',
                          lineHeight: "199%",
                        }}
                      >
                        {item.captionDescription}
                      </p>
                    </div>
                    <div>
                      <Image style={{ marginTop: "50%" }} src={navarrow} />
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      gap: "10px",
                      flexWrap: "wrap",
                      marginBottom: "0.5rem",
                    }}
                  >
                    {item.sub.map((subItem) => (
                      <div
                        style={{
                          fontSize: "0.6rem",
                          backgroundColor: "grey",
                          borderRadius: "5rem",
                          padding: "0.3rem 1rem",
                        }}
                        key={subItem}
                      >
                        {subItem}
                      </div>
                    ))}
                  </div>
                </figcaption>
              </figure>
            </Link>
          )}
          </Container>
        ))}
      </Carousel>
    </>
  );
}

export default ProjectList;
